var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaperclipRegular(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.207 15.293a1 1 0 010 1.415l-10.256 10.25a7.001 7.001 0 01-9.9-9.901l12.407-12.59a5.001 5.001 0 117.077 7.068l-12.41 12.59a3.005 3.005 0 11-4.25-4.25L19.287 9.298a1 1 0 111.425 1.402L10.298 21.29a1.002 1.002 0 00.318 1.632 1.002 1.002 0 001.091-.213l12.409-12.584a3.002 3.002 0 10-4.241-4.25L7.47 18.46a5 5 0 107.066 7.078l10.257-10.25a1 1 0 011.414.005z"
  })));
}
export default SvgPaperclipRegular;